import { createSelector } from 'reselect';

const networkSelector = state => state.network;

export const isOnlineSelector = createSelector(
  networkSelector,
  state => state.online
);
